angular.module('unergie.main')
.run((amMoment) => amMoment.changeLocale('fr'))
.constant('angularMomentConfig', {
    timezone: 'Europe/Paris',
})
